module.exports = __webpack_public_path__ + "static/media/HDJN01.a1fa183d.jpg";